import React from 'react'
import { DialogContent, DialogActions, Box, Button, List } from '@mui/material'
import { StatusListItem } from './StatusListItem'

export interface StatusItem {
  name: string
  isDefault: boolean
}

interface EditStatusListProps {
  displayList: StatusItem[]
  editingStatus: string | null
  renameInput: string
  onRenameInputChange: (val: string) => void
  onInitiateRename: (oldStatus: string) => void
  onCancelRename: () => void
  onStartEdit: (status: string) => void
  onClose: () => void
  isLoading: boolean
  error: string | null
}

export const EditStatusList: React.FC<EditStatusListProps> = ({
  displayList,
  editingStatus,
  renameInput,
  onRenameInputChange,
  onInitiateRename,
  onCancelRename,
  onStartEdit,
  onClose,
  isLoading,
  error,
}) => {
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', width: '100%', boxSizing: 'border-box' }}>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', flex: 1, gap: 1.5, pt: 2, pb: 1, px: 3, width: '100%', boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, width: '100%', boxSizing: 'border-box' }}>
          <List
            dense
            sx={{
              p: 0,
              flex: 1,
              overflowY: 'auto',
              overflowX: 'hidden',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}
          >
            {displayList.map(({ name: statusName, isDefault }) => (
              <StatusListItem
                key={statusName}
                statusName={statusName}
                isDefault={isDefault}
                isEditing={editingStatus === statusName}
                renameInput={renameInput}
                onRenameInputChange={onRenameInputChange}
                onInitiateRename={onInitiateRename}
                onCancelRename={onCancelRename}
                onStartEdit={onStartEdit}
                isLoading={isLoading}
                error={error}
              />
            ))}
          </List>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0, flexShrink: 0, justifyContent: 'flex-end', gap: 1 }}>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Box>
  )
}
